import React, {useState} from 'react'
import { PiShieldDuotone } from 'react-icons/pi';
import { ImCheckboxChecked,ImCheckboxUnchecked } from 'react-icons/im';
import { createDialog } from 'coaz-ui';

export function useIAgree() {
    const [iAgree,setIAgree] = useState(false);

    return {iAgree:iAgree,setIAgree:setIAgree}
}

export function IAgree({iAgree,setIAgree}) {
    const showPrivacyPolicy = () => {
        createDialog({
            title:"Privay Policy",
            Component:PrivacyPolicy
        })
    }
    return (
        <div className={`flex flex-row max-w-full w-fit h-fit justify-center items-center shrink-0 space-x-2 overflow-hidden`}>
            <button onClick={() => {setIAgree(!iAgree);}} className='w-fit h-fit text-[rgb(0,175,240)] shrink-0'>
                {iAgree?<ImCheckboxChecked size={16}/>:
                <ImCheckboxUnchecked size={16}/>}
            </button>
            <div className='flex flex-wrap w-full overflow-hidden h-fit'>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>I</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>have</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>read</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>the</span>
                <button onClick={showPrivacyPolicy} className='h-5 my-auto mr-1 text-sm text-[rgb(0,175,240)] hover:underline'>privacy policy</button>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>and</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>agree</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>to</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>the</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>COAZ</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>terms</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>and</span>
                <span className='h-5 my-auto mr-1 text-sm text-gray-600'>conditions</span>
            </div>
        </div>
    )
}

const PrivacyPolicy = () => {
    return (
        <div className='flex flex-col w-[90vw] sm:w-[640px] bg-white h-fit py-4 justify-between font-helveticaNeueRegular  rounded-xl overflow-hidden'>
            <div className='flex flex-col w-full space-y-4 h-fit'>
                <div className='flex flex-col items-center justify-center w-full h-fit text-[rgb(0,175,240)]'>
                    <PiShieldDuotone size={64}/>
                    <span className='text-lg tracking-wider uppercase font-helveticaNeueRegular'>Privacy Policy</span>
                </div>
                <p className='w-full p-4 text-sm/8 text-text'>
                    {`By using this website and submitting your personal information through any of its forms, you expressly 
                    consent to the Clinical Officers' Association Zambian (COAZ) collecting, storing, and processing your 
                    personal data in accordance with the Data Protection Act No. 3 of 2021. This data will be used solely 
                    for purposes related to the Association's functions, including communication, membership management, 
                    regulatory compliance, and service improvement.`}
                </p>
            </div>
        </div>
    )
}
 